import { Component, input } from '@angular/core';
import { IconComponent } from '../../../components/icon/icon.component';
import { PercentPipe } from '../../../pipes/percent.pipe';
import { AssetAllocationStatus } from '../../../domain/lti/investment-portfolio.domain';

@Component({
  selector: 'td-wb-portfolio-asset-allocation-status',
  templateUrl: 'portfolio-asset-allocation-status.component.html',
  styleUrls: ['portfolio-asset-allocation-status.scss'],
  imports: [
    IconComponent,
    PercentPipe
  ]
})
export class PortfolioAssetAllocationStatusComponent {
  readonly assetAllocationStatus = input<AssetAllocationStatus>(undefined);

  getHostClass(): string {
    const base = 'td-wb-portfolio-asset-allocation-status';
    const modifier = this.assetAllocationStatus().status === 'BALANCED' ? 'balanced' : 'not-balanced';
    return `${base} ${base}--${modifier}`;
  }

  getDeviance(): number {
    return Math.abs(this.assetAllocationStatus().pctDeviance);
  }
}

